/** @format */

import React from 'react';
import FilterActiveItem from './filter_active_item';

export default class extends React.Component {
    render() {
        let filter_count = this.props.filters.length;
        if (filter_count === 0) {
            return null;
        }
        return (
            <div className="active-filter-list d-flex align-items-center" style={{marginTop: 8}}>
                {this.props.filters.map((filter, i) => {
                    return (
                        <FilterActiveItem
                            {...filter}
                            totalFilters={filter_count}
                            index={i}
                            key={i}
                            onRemove={this.props.onRemove.bind(this, filter.query)}
                        />
                    );
                })}
            </div>
        );
    }
}
